import { playSynthesizedSound } from '../utils/audioUtils';

/**
 * Plays sound files, remembering which ones are missing so it can fall back
 * to a synthesized sound straight away next time.
 */
export default class SoundPlayer {
  constructor() {
    this.isMuted = false;
    this.missingPaths = new Set();
  }

  setMuted(isMuted) {
    this.isMuted = isMuted;
  }

  play(soundPath, fallbackRecipeKey) {
    if (this.isMuted) return;
    if (!soundPath || this.missingPaths.has(soundPath) || typeof Audio === 'undefined') {
      playSynthesizedSound(fallbackRecipeKey);
      return;
    }
    const audio = new Audio(soundPath);
    const useFallback = () => {
      this.missingPaths.add(soundPath);
      playSynthesizedSound(fallbackRecipeKey);
    };
    audio.addEventListener('error', useFallback, { once: true });
    audio.play()?.catch(useFallback);
  }
}
